export function trackContentsquare(command) {
  if (typeof window === 'undefined') return;
  window._uxa = window._uxa || [];
  window._uxa.push(command);
}

export function setAuthenticatedContentsquareVariables(account) {
  if (!account?.id || !account.email) return;
  const registeredAt = account.createdAt || account.accountCompliance?.createdAt;
  const isTrial = registeredAt && Date.now() - new Date(registeredAt).getTime() < 10 * 24 * 60 * 60 * 1000;
  trackContentsquare(['setCustomVariable', 1, 'estado_cuenta', isTrial ? 'prueba' : 'activo', 2]);
  trackContentsquare(['setCustomVariable', 2, 'correo_usuario', account.email, 2]);
}

export function trackContentsquareEvent(eventName) {
  trackContentsquare(['trackPageEvent', eventName]);
}
